import { ShoppingCart, X } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

interface OnboardModalProps {
    onClose: () => void;
}

const OnboardModal: React.FC<OnboardModalProps> = ({ onClose }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[110] px-4">
            <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-[600px] flex flex-col items-center justify-center text-center relative">
                <X className=" absolute right-4 top-4 cursor-pointer" onClick={onClose} />
                <ShoppingCart className=" text-[#317333] mb-3 w-8" />
                <h2 className="text-2xl text-[#272D37] font-Manrope font-bold mb-2 ">
                    Sign Up to Checkout
                </h2>
                <p className=" font-Manrope text-base md:text-lg text-[#272D37] font-medium">
                    Sign up or log in to complete your purchase, track your order, and
                    unlock exclusive member perks.
                </p>

                <div className=" w-full grid grid-cols-2 gap-4">
                    <Link
                        to="/dashboard?page=Shop"
                        className="mt-4 px-4 py-2 rounded-md font-medium text-base font-Manrope text-[#272D37] border border-[#DAE0E6]"
                    >
                        Login
                    </Link>
                    <Link
                        to="/sign-up"
                        className="mt-4 px-4 py-2 bg-[#317333]  text-white rounded-md font-medium text-base font-Manrope "
                    >
                        Sign up
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default OnboardModal;
